import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.development';
import { DataLesson, Lesson } from '../shared/interfaces/lesson.interface';
import { Observable, Subject, catchError, map, retry, throwError } from 'rxjs';
import { DataCourse } from '../shared/interfaces/course.interface';

const API_URL = environment.apiUrl;


@Injectable({
  providedIn: 'root'
})
export class LessonsService {

  lessons: any[][] = [];
  onUpdateLocalLessonCheckedStatus$ = new Subject<DataLesson | undefined>();
  onUpdateLocalLessonLoadPercent$ = new Subject<{
    percentage: number;
    course: DataCourse | undefined;
} | undefined>();
  constructor(private http: HttpClient) { }
  evaluationStatus$ = new Subject<boolean | undefined>();
  getLessons(): Observable<DataLesson[]> {
    const url = `${API_URL}/lessons?sort=title`;
    return this.http.get<Lesson>(url)
      .pipe(
        map(resp => resp.data)
      );
  }

  getLessonById(id: string | undefined): Observable<DataLesson> {
    return this.getLessons()
      .pipe(
        map(lessons => {
          const lesson = lessons.find(lesson => lesson.id === id);
          if (!lesson) throw new Error('Lección no encontrada');
          return lesson;
        }),
        retry(1), catchError(this.handleError)
      );
  }

  getLessonDetail(id: string): Observable<DataLesson> {
    const url = `${API_URL}/lessons/${id}`;
    return this.http.get<any>(url).pipe(
      map(resp => resp.data),
      retry(1), catchError(this.handleError)
    )
  }

  // getLessonsOfModuleById(id:string):Observable<DataLesson[]>{
  //   const url = `${API_URL}/lessons?filter[field_module.id][value]=${id}`;
  //   return this.http.get<Lesson>(url).pipe(
  //     map(resp => resp.data)
  //   );
  // }

  getLessonsOfModuleById(id:string):Observable<DataLesson[]>{
    const url = `${API_URL}/lessons?sort=title&filter[field_module.id][value]=${id}`;
    return this.http.get<Lesson>(url).pipe(
      map(resp => resp.data)
    );
  }

  getLessonsOfCourseById(id:string):Observable<DataLesson[]>{
    const url = `${API_URL}/lessons?sort=title&filter[field_course.id][value]=${id}`;
    return this.http.get<Lesson>(url).pipe(
      map(resp => resp.data)
    );
  }



  //Manejador de errores
  private handleError(error:any) {
    let errorMessage = '';
    (error.error instanceof ErrorEvent) ?  errorMessage = `Error: ${error.error.message}`
    : errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    return throwError(() => {
        return errorMessage;
    });
  }
}
